"use strict";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Flame, Trophy, Gamepad2, Target } from "lucide-react";
const promotions = [{
  id: "promo-cricket",
  title: "Chiropractic Care",
  description: "Restore your body's natural alignment and improve nervous system function through precise manual therapy. Our expert practitioners focus on relieving chronic pain and enhancing mobility for long-term health. Experience a personalized approach tailored to your specific physical needs and lifestyle.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/promo_cricket_action.png",
  icon: Target,
  badgeText: "Clinical",
  link: "/TreatmentsPage"
}, {
  id: "promo-football",
  title: "Dry Needling",
  description: "Combine ancient wisdom with modern clinical techniques to release muscle tension and promote internal healing. This specialized treatment targets trigger points to reduce inflammation and accelerate your recovery process. Ideal for both acute injuries and chronic stress-related physical tension.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/promo_football_stadium.png",
  icon: Trophy,
  badgeText: "Holistic",
  link: "/TreatmentsPage"
}, {
  id: "promo-casino",
  title: "Massage Therapy",
  description: "Relieve muscle soreness and improve circulation with therapeutic massage techniques designed for deep relaxation and recovery. Our therapists integrate multiple modalities to address your unique musculoskeletal concerns effectively. Perfect for stress reduction and maintaining peak physical performance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1609030/img/promo_casino_roulette.png",
  icon: Gamepad2,
  badgeText: "Wellness",
  link: "/TreatmentsPage"
}];
export default function FeaturedPromotions() {
  return <section data-section-id="168946" id="detailed-treatments-grid" className="relative py-24 bg-background text-foreground overflow-hidden z-0">
      {}
      <div className="absolute top-0 left-0 w-full h-32 bg-muted/30 origin-top-left -skew-y-3 -z-10 transform-gpu" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-6xl font-serif font-medium tracking-normal text-primary mb-4">
            Clinical <span className="text-accent">Expertise</span>
          </h2>
          <p className="text-secondary max-w-2xl mx-auto text-xl font-sans">
            Comprehensive healthcare solutions tailored to your body's unique needs at our Limassol and Nicosia clinics.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-6 lg:gap-8 justify-center items-stretch">
          {promotions.map((promo, i) => {
          const Icon = promo.icon;
          return <Card key={promo.id} data-index={i} className="flex-1 bg-card border-border hover:border-secondary shadow-md hover:shadow-lg transition-all duration-500 overflow-hidden group rounded-2xl flex flex-col">
                {}
                <div className="relative h-56 sm:h-64 w-full [clip-path:polygon(0_0,100%_0,100%_92%,0_100%)] overflow-hidden bg-muted">
                  <img src={promo.image} alt={promo.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-60" />
                  
                  {}
                  <Badge variant="default" className="absolute top-4 left-4 bg-accent text-accent-foreground shadow-sm px-3 py-1 text-sm border-none rounded-full">
                    <Flame className="w-4 h-4 mr-1.5" />
                    {promo.badgeText}
                  </Badge>
                </div>

                <CardContent className="pt-6 pb-8 px-6 flex flex-col flex-1 relative z-10">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="p-2 bg-accent/10 rounded-lg text-accent">
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="font-serif font-medium tracking-normal text-2xl text-primary group-hover:text-accent transition-colors line-clamp-1">
                      {promo.title}
                    </h3>
                  </div>
                  
                  <p className="text-secondary mb-8 flex-1 leading-relaxed font-sans">
                    {promo.description}
                  </p>

                  {}
                  <Button asChild size="lg" className="w-full rounded-full bg-accent text-accent-foreground hover:bg-accent/90 shadow-sm hover:shadow-md transition-all duration-300 hover:scale-105 group/btn overflow-hidden relative">
                    <Link to={promo.link}>
                      <span className="relative z-10 font-sans font-semibold tracking-wide uppercase">View Details</span>
                      {}
                      <div className="absolute inset-0 bg-white/10 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-300 ease-in-out" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}